/**
 * @generated SignedSource<<6c9bdc9f12d136620433c60a7d327b89>>
 * @relayHash 7def46663fdb979bab25db3df411ce1a
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/581.0.0-2026-10-07T20:22:49.160Z/UserNotificationsTabsQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserNotificationsTabsQuery$variables = {
  hasTradeUserId: boolean;
  priceBookName: string;
  showPriceDropNotifications?: boolean | null;
  userCountryCode: string;
  userId: string;
};
export type UserNotificationsTabsQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"UserNotificationsTabs_viewer">;
  };
};
export type UserNotificationsTabsQuery = {
  response: UserNotificationsTabsQuery$data;
  variables: UserNotificationsTabsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasTradeUserId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showPriceDropNotifications"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v5 = {
  "kind": "Variable",
  "name": "showPriceDropNotifications",
  "variableName": "showPriceDropNotifications"
},
v6 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestMessage",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestMessageReceivedAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": "thumb"
    }
  ],
  "kind": "ScalarField",
  "name": "firstPhotoWebPath",
  "storageKey": "firstPhotoWebPath(size:\"thumb\")"
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Item",
  "kind": "LinkedField",
  "name": "item",
  "plural": false,
  "selections": [
    (v12/*:: as any*/),
    (v13/*:: as any*/),
    (v14/*:: as any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "Member",
  "kind": "LinkedField",
  "name": "buyerMember",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasUnreadTag",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasUnviewedTag",
      "storageKey": null
    },
    (v14/*:: as any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v19 = [
  (v9/*:: as any*/),
  (v14/*:: as any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotificationsTag",
  "kind": "LinkedField",
  "name": "unreadTag",
  "plural": false,
  "selections": (v19/*:: as any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotificationsTag",
  "kind": "LinkedField",
  "name": "unviewedTag",
  "plural": false,
  "selections": [
    (v8/*:: as any*/),
    (v14/*:: as any*/),
    (v9/*:: as any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Item",
  "kind": "LinkedField",
  "name": "item",
  "plural": false,
  "selections": [
    (v9/*:: as any*/),
    (v12/*:: as any*/),
    (v13/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    },
    (v14/*:: as any*/)
  ],
  "storageKey": null
},
v23 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "hasTradeUserId"
},
v24 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v27 = [
  (v25/*:: as any*/),
  (v26/*:: as any*/)
],
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v27/*:: as any*/),
  "storageKey": null
},
v29 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            (v23/*:: as any*/),
            {
              "kind": "Literal",
              "name": "page",
              "value": "favorites"
            },
            (v24/*:: as any*/)
          ],
          "concreteType": "ItemDisplayPriceType",
          "kind": "LinkedField",
          "name": "displayPrice",
          "plural": true,
          "selections": [
            (v28/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ConvertedAmountList",
              "kind": "LinkedField",
              "name": "originalConvertedAmountList",
              "plural": true,
              "selections": (v27/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "percentageOff",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RetailPriceHistoryItem",
              "kind": "LinkedField",
              "name": "retailPriceHistory",
              "plural": true,
              "selections": [
                (v18/*:: as any*/),
                (v28/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PriceDropFavoriteNotification",
  "abstractKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*:: as any*/)
  ],
  "type": "PriceDropFavoriteNotification",
  "abstractKey": null
},
v31 = [
  (v26/*:: as any*/),
  (v25/*:: as any*/)
],
v32 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmountList",
    "kind": "LinkedField",
    "name": "convertedAmountList",
    "plural": true,
    "selections": (v31/*:: as any*/),
    "storageKey": null
  }
],
v33 = [
  (v14/*:: as any*/)
],
v34 = {
  "kind": "InlineFragment",
  "selections": (v33/*:: as any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Anchor",
  "kind": "LinkedField",
  "name": "anchors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "source",
      "plural": false,
      "selections": [
        (v8/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "token",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Transaction",
              "kind": "LinkedField",
              "name": "transaction",
              "plural": false,
              "selections": [
                (v15/*:: as any*/),
                (v14/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "OrderFeedback",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LoyaltyProgram",
              "kind": "LinkedField",
              "name": "programInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                (v14/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "ParentProgram",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "rewardEarned",
              "plural": false,
              "selections": (v31/*:: as any*/),
              "storageKey": null
            }
          ],
          "type": "TradeFirmReward",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            (v9/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "TransactionSummaryObject",
              "kind": "LinkedField",
              "name": "summary",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "offerDiscountPercentage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": [
                (v9/*:: as any*/),
                (v12/*:: as any*/),
                (v13/*:: as any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "buyerId",
                      "variableName": "userId"
                    },
                    (v23/*:: as any*/),
                    (v24/*:: as any*/),
                    {
                      "kind": "Variable",
                      "name": "userCountryCode",
                      "variableName": "userCountryCode"
                    }
                  ],
                  "concreteType": "ItemDisplayPriceType",
                  "kind": "LinkedField",
                  "name": "displayPrice",
                  "plural": true,
                  "selections": (v32/*:: as any*/),
                  "storageKey": null
                },
                (v14/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Offer",
              "kind": "LinkedField",
              "name": "mostRecentOffer",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "amountPerItem",
                  "plural": false,
                  "selections": (v32/*:: as any*/),
                  "storageKey": null
                },
                (v14/*:: as any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Conversation",
              "kind": "LinkedField",
              "name": "conversation",
              "plural": false,
              "selections": (v19/*:: as any*/),
              "storageKey": null
            }
          ],
          "type": "Transaction",
          "abstractKey": null
        },
        (v34/*:: as any*/),
        {
          "kind": "InlineFragment",
          "selections": (v33/*:: as any*/),
          "type": "Category",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNotificationsTag",
  "kind": "LinkedField",
  "name": "unviewedTag",
  "plural": false,
  "selections": [
    (v8/*:: as any*/),
    (v14/*:: as any*/)
  ],
  "storageKey": null
},
v37 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserNotification",
    "kind": "LinkedField",
    "name": "all",
    "plural": true,
    "selections": [
      (v7/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "payload",
        "plural": false,
        "selections": [
          (v8/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/)
            ],
            "type": "Conversation",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              (v22/*:: as any*/),
              (v29/*:: as any*/)
            ],
            "type": "FavoriteNotification",
            "abstractKey": "__isFavoriteNotification"
          },
          (v30/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              (v35/*:: as any*/)
            ],
            "type": "ActivityFeedElement",
            "abstractKey": null
          },
          (v34/*:: as any*/)
        ],
        "storageKey": null
      },
      (v8/*:: as any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Conversation",
    "kind": "LinkedField",
    "name": "messages",
    "plural": true,
    "selections": [
      (v9/*:: as any*/),
      (v10/*:: as any*/),
      (v11/*:: as any*/),
      (v15/*:: as any*/),
      (v16/*:: as any*/),
      (v14/*:: as any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "favorites",
    "plural": true,
    "selections": [
      (v8/*:: as any*/),
      {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isFavoriteNotification"
      },
      (v9/*:: as any*/),
      (v17/*:: as any*/),
      (v18/*:: as any*/),
      (v20/*:: as any*/),
      (v36/*:: as any*/),
      (v22/*:: as any*/),
      (v29/*:: as any*/),
      (v34/*:: as any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ActivityFeedElement",
    "kind": "LinkedField",
    "name": "other",
    "plural": true,
    "selections": [
      (v9/*:: as any*/),
      (v17/*:: as any*/),
      (v18/*:: as any*/),
      (v20/*:: as any*/),
      (v36/*:: as any*/),
      (v35/*:: as any*/),
      (v14/*:: as any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserNotification",
    "kind": "LinkedField",
    "name": "offers",
    "plural": true,
    "selections": [
      (v7/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "payload",
        "plural": false,
        "selections": [
          (v8/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v20/*:: as any*/),
              (v36/*:: as any*/),
              (v35/*:: as any*/)
            ],
            "type": "ActivityFeedElement",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v20/*:: as any*/),
              (v36/*:: as any*/),
              (v22/*:: as any*/),
              (v29/*:: as any*/)
            ],
            "type": "FavoriteNotification",
            "abstractKey": "__isFavoriteNotification"
          },
          (v30/*:: as any*/),
          (v34/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserNotificationsTabsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v5/*:: as any*/)
            ],
            "kind": "FragmentSpread",
            "name": "UserNotificationsTabs_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*:: as any*/),
      (v0/*:: as any*/),
      (v3/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "UserNotificationsTabsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v5/*:: as any*/),
              (v6/*:: as any*/)
            ],
            "concreteType": "UserNotifications",
            "kind": "LinkedField",
            "name": "userNotifications",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNotificationsBucket",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": (v37/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNotificationsBucket",
                "kind": "LinkedField",
                "name": "earlier",
                "plural": false,
                "selections": (v37/*:: as any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              (v6/*:: as any*/)
            ],
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Promotion",
                "kind": "LinkedField",
                "name": "activePromotion",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "buyerDisplayable",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PromotionMeta",
                    "kind": "LinkedField",
                    "name": "promotionMeta",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayMessage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayCta",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "adjustmentRateList",
                    "plural": true,
                    "selections": [
                      (v8/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reference",
                        "storageKey": null
                      },
                      (v34/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "code",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FlatAdjustmentRate",
                    "kind": "LinkedField",
                    "name": "flatAdjustmentRate",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "kind": "LinkedField",
                        "name": "rate",
                        "plural": false,
                        "selections": (v31/*:: as any*/),
                        "storageKey": null
                      },
                      (v14/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PercentAdjustmentRate",
                    "kind": "LinkedField",
                    "name": "percentAdjustmentRate",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rate",
                        "storageKey": null
                      },
                      (v14/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v14/*:: as any*/)
                ],
                "storageKey": null
              },
              (v14/*:: as any*/)
            ],
            "storageKey": null
          },
          (v14/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "ferrum/581.0.0-2026-10-07T20:22:49.160Z/UserNotificationsTabsQuery",
    "metadata": {},
    "name": "UserNotificationsTabsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7cf70838bbfc3be65653a384aefe2e28";

export default node;
